module.exports = require("lodash/difference");